<!-- <footer>© 2025 copyright | About Us | Work With Us | Privacy Policy | Terms | Disclosure Policy |</footer> -->
  <!-- Desktop Footer -->
    <footer class="hidden lg:block bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-12">
        <div class="container mx-auto px-6">
            <div class="grid grid-cols-4 gap-8">
                <div>
                    <h3 class="text-lg font-bold text-wattpad-primary mb-4">Funtel Studio</h3>
                    <p class="text-sm text-wattpad-light mb-4">The world's most vibrant Funtel community.</p>
                    <div class="flex space-x-4">
                        <a href="#" class="text-wattpad-light hover:text-wattpad-primary transition-colors">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a href="#" class="text-wattpad-light hover:text-wattpad-primary transition-colors">
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a href="#" class="text-wattpad-light hover:text-wattpad-primary transition-colors">
                            <i class="fab fa-instagram"></i>
                        </a>
                        <a href="#" class="text-wattpad-light hover:text-wattpad-primary transition-colors">
                            <i class="fab fa-tiktok"></i>
                        </a>
                    </div>
                </div>
                
                <div>
                    <h4 class="font-bold mb-4">Discover</h4>
                    <ul class="space-y-2">
                        <li><a href="#" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Browse Stories</a></li>
                        
                        <li><a href="#" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Community</a></li>
                        <li><a href="#" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Events</a></li>
                    </ul>
                </div>
                
                <div>
                    <h4 class="font-bold mb-4">Write</h4>
                    <ul class="space-y-2">
                        <li><a href="new" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Start Writing</a></li>
                        
                        <li><a href="contest" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Writer Contests</a></li>
                       
                    </ul>
                </div>
                
                 <div>
                    <h4 class="font-bold mb-4">Company</h4>
                    <ul class="space-y-2">
                        <li><a href="about" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">About</a></li>
                        <li><a href="refund" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Refund and Cancellation</a></li>
                        <li><a href="product-and-description" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Product and Description</a></li>
                        <li><a href="contact" class="text-sm text-wattpad-light hover:text-wattpad-primary transition-colors">Contact</a></li>
                    </ul>
                </div> 
            </div>
            
            <div class="border-t border-gray-200 dark:border-gray-700 mt-12 pt-8">
                <div class="flex flex-wrap justify-between items-center">
                    <p class="text-xs text-wattpad-light">&copy; {{ (getCurrentDate() | date:'yyyy') }} Funtel Studio. All rights reserved.</p>
                    <div class="flex space-x-4">
                        <a href="terms_and_condition" class="text-xs text-wattpad-light hover:text-wattpad-primary transition-colors">Terms</a>
                        <a href="privacy" class="text-xs text-wattpad-light hover:text-wattpad-primary transition-colors">Privacy</a>
                        <!-- <a href="#" class="text-xs text-wattpad-light hover:text-wattpad-primary transition-colors">Guidelines</a>
                        <a href="#" class="text-xs text-wattpad-light hover:text-wattpad-primary transition-colors">Help</a> -->
                    </div>
                </div>
            </div>
        </div>
    </footer>

    <!-- Mobile Bottom Navigation -->
    <nav class="bottom-nav fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 lg:hidden">
        <div class="flex justify-around items-center h-full">
            <a href="home" class="text-wattpad-primary flex flex-col items-center">
                <i class="fas fa-home text-xl"></i>
                <span class="text-xs mt-1">Home</span>
            </a>
            <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fa-list fas text-xl"></i>
                <span class="text-xs mt-1">Category</span>
            </a>
            <a href="new" class="fab-button bg-wattpad-primary text-white p-4 rounded-full -mt-10 flex items-center justify-center">
                <i class="fas fa-plus text-xl"></i>
            </a>
            <a href="library" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-bookmark text-xl"></i>
                <span class="text-xs mt-1">Library</span>
            </a>
            <a href="user-profile" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-user text-xl"></i>
                <span class="text-xs mt-1">Profile</span>
            </a>
        </div>
    </nav>